<template>
  <div>
    <div v-if="isCollection!='1'">
      <el-input class="commbo-input" style="width:100%;" clearable v-model="searchWord">
        <span style="cursor:pointer" @click="search(true)" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
      </el-input>
    </div>
    <div style="position: relative;">
      <div ref="scrollContainer" class="table" :style="{'height':tableHeight}" v-if="productList.length" v-infinite-scroll="search" :infinite-scroll-distance="10">
        <div class="product-wrapper" v-for="(item,index) in productList" :key="index">
          <template v-if="!noNeedSelect">
            <el-checkbox v-if="isMultiple=='1'" v-model="item.checked"></el-checkbox>
            <el-radio v-else v-model="single_select" :label="item.id" style="margin-right:0;">&nbsp;</el-radio>
          </template>
          <div style="text-align: center;flex:1">
            <template v-if="item.enable_alternate_images==1">
              <img v-if="item.alternate_image_list.length" :src="item.alternate_image_list[0].small" style="width:150px;height:150px;object-fit: contain;"/>
              <div class="plh_img" style="height:150px;" v-else>
                <div v-if="item[item.unique_param]" class="plh_img_walk" :style="{backgroundImage:'url('+item[item.unique_param].color_image_url+')'}"></div>
              </div>
            </template>
            <img v-else :src="item.cover_image?item.cover_image.small:''" style="width:150px;height:150px;object-fit: contain;"/>
            <p class="product-name" style="margin:5px 0;">{{ item.name }}</p>
            <div>
                <del v-if="item.price!='--' && item.price != item.discounted_price" style="font-size:9px;">{{item.currency_symbol}}{{item.price}}</del><span class="product-price" :class="{'discounted':item.price != item.discounted_price}">{{item.price!='--'?item.currency_symbol:''}}{{item.discounted_price}}</span><span v-if="item.price!='--'" style="font-size:9px;margin-left:3px;">{{ item.currency }}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="height:400px;display: flex;align-items: center;justify-content: center;" v-else>
        <!--<p v-if="!searching">{{ searchWord?'没有相关商品':'请输入关键字搜索商品' }}</p>-->
        <p style="color:rgba(51,51,51,0.6)" v-if="!searching">没有相关商品</p>
      </div>
      <div v-if="continueSearching" style="position:absolute;bottom:0;left:0;height:20px;width:100%;text-align: center;">
        <i class="el-icon-loading"></i>
      </div>
    </div>
    <div v-if="!noNeedSelect">
      <el-button style="margin-bottom:20px;" class="block" type="primary" @click="confirm()">{{ isMultiple=='1'?'确定关联':'确定绑定' }}</el-button>
    </div>
  </div>
</template>

<script>
import api from '../services/api.js'

export default {
  name: 'HelloWorld',
  data () {
    return {
      productList:[],
      totalCount:0,
      searching:false,
      continueSearching:false,
      searchWord:'',
      currentPage:1,
      single_select:'',
    }
  },
  props:['articleId','merchant_id','isMultiple','isCollection','noNeedSelect','fullscreen','tableHeight'],
  mounted() {
    this.searching=true;
    this.$emit('startloading');
    let params = {page:1,limit:10}
    if(this.merchant_id){
      if(this.isCollection=='1')
        params.merchant_id=this.merchant_id
      else
        params.merchant_id_list=[this.merchant_id]
    }
    this.getList(params,true);
  },
  watch:{
    merchant_id(){
      this.searching=true;
      let params = {page:1,limit:10}
      if(this.merchant_id){
        console.log('isCo',this.isCollection);
        if(this.isCollection=='1')
          params.merchant_id=this.merchant_id
        else
          params.merchant_id_list=[this.merchant_id]
      }
      else{
        if(this.isCollection=='1')
          params.merchant_id=''
        else
          params.merchant_id_list=[]
      }
      this.getList(params,true);
    }
  },
  methods:{
    confirm(){
      if(this.isMultiple=='1'){
        let list = this.productList.filter((l)=>l.checked);
        this.$emit('select',list,this.isCollection);
      }
      else{
        let product = this.productList.find((i)=>i.id==this.single_select)
        this.$emit('select',product)
      }
    },
    getList(params,needReload) {
      const handleData = (res)=>{
        let list = res.body.result;
        list.forEach((i,index)=>{
          i.checked=false;
          if(i.price==-9999 || i.price=='-9999.00'){
            i.price='--';
            i.discounted_price='--';
          }
        })
        if(needReload){
          this.productList=list;
          this.searching=false;
        }
        else{
          this.continueSearching=false;
          this.productList.push(...list);
        }
      }
      const handleFavData = (res)=>{
        let list = res.body.result;
        this.$emit('finishloading');
        console.log('test',this.merchant_id,needReload,list);
        if(this.merchant_id=='' && needReload){
          this.$emit('total_fav',list.length);
        }
        list.forEach((i,index)=>{
          if(i.type=='merchant_good'){
            i.id = i.good_id;
            i.default_merchant_id = i.merchant_id;
            i.price = i.url_content.price;
            i.discounted_price = i.url_content.discounted_price;
            i.currency = i.url_content.currency;
            i.currency_symbol = i.url_content.currency_symbol;
            i.cover_image = {}
            i.cover_image.small = i.url_image_url
          }
          else if(i.type=='url'){
            i.url_content.name = i.name;
            i.price = i.url_content.price;
            i.discounted_price = i.url_content.discounted_price;
            i.currency = i.url_content.currency;
            i.currency_symbol = i.url_content.currency_symbol;
            i.cover_image = {}
            i.cover_image.small = i.url_image_url
          }
          
          i.checked=false;
          if(i.price==-9999 || i.price=='-9999.00'){
            i.price='--';
            i.discounted_price='--';
          }
          else{
            if(typeof i.price === "number"){
              i.price=i.price.toFixed(2);
              i.discounted_price=i.discounted_price.toFixed(2);
            }
          }
        })
        if(needReload){
          this.productList=list;
          this.searching=false;
        }
        else{
          this.continueSearching=false;
          this.productList.push(...list);
        }
      }
      console.log('params',params);
      if(this.isCollection=='1'){
        api.getCollectionProductList(this,params).then((res) => {
          handleFavData(res)
        })
      }
      else{
        api.getProductList(this,params.page,params.limit,params).then((res) => {
          handleData(res)
        })
      }
    },
    getListCount(params){
      delete params.page
      delete params.limit
      api.getArticleCount(this,params).then((res)=>{
        this.totalCount=+res.body.result;
      })
    },
    search(needReload){
      const generateParams=(needReload)=>{
        let params={}
        params.limit=10;
        if(this.merchant_id){
          console.log('colle',this.isCollection);
          if(this.isCollection=='1'){
            params.merchant_id=this.merchant_id
          }
          else{
            params.merchant_id_list=[this.merchant_id]
          }
        }
        if(needReload){
          this.$refs.scrollContainer.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          params.page=1;
          this.searching=true;
        }
        else{
          this.currentPage++;
          params.page=this.currentPage;
          this.continueSearching=true;
        }
        if(this.searchWord.trim()!='')
          params.keyword=this.searchWord
        return params
      }
      let params=generateParams(needReload);
      this.getList(params,needReload);
      /*if(needReload)
        this.getListCount(params);*/
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .imgdivwrapper{
    height:100%;
    position: relative;
  }
  .right-article-detail{
    overflow: auto;
    height:calc(100% - 110px)
  }
  .right-article-detail::-webkit-scrollbar{
    display: none;
  }
  .el-icon-star-on{
    font-size: 28px;
  }
  .el-icon-star-off{
    font-size: 24px;;
  }
  .header {
    border-bottom: 1px solid #d7d7d7;
  }
  .crumbs {
    margin-top: 34px;
    max-width: 1200px;
    margin: 34px auto 10px;
  }
  .main-content {
    padding-top: 70 + 116px;
    .select-shop {
      max-width: 760px;
      margin: 0 auto;
    }
    .publish-task-product {
      max-width: 1140px;
      margin: 0 auto;
    }
  }

  @media screen and (max-width:1024px){
    .main-content {
      padding-top: 50px;
    }
  }
  .article-comment{
    display: flex;
    margin-bottom:16px;
  }
  .table{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    overflow: auto;
    margin:10px 0;
  }
  .table::-webkit-scrollbar {
    display: none;
  }
  .product-wrapper{
    width:25%;
    height: 220px;
    display: flex;
    max-width: 220px;
  }
  .product-price{
    color:#333;
    font-size:12px;
    &.discounted{
      color:#ff4650;
    }
  }
  .product-name{
    line-height: 15px;
    color:#333;
    text-overflow: ellipsis;
    height: 32px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    word-break: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductList.vue